import TipBlock from './TipBlock';
import './TipBlock.scss';

export default TipBlock;
